import { render } from "./patnersComponent.vue?vue&type=template&id=4923ea3b&scoped=true"
const script = {}

import "./patnersComponent.vue?vue&type=style&index=0&id=4923ea3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4923ea3b"]])

export default __exports__